import { Directive } from '@angular/core';

@Directive({
  selector: 'tab3',
  standalone: false,
})
export class Tab3Directive {}
